export var SMALL = 5;
export var BIG = 10;
//# sourceMappingURL=index.js.map